import { render, staticRenderFns } from "./DriversLeave.vue?vue&type=template&id=680ab280&"
import script from "./DriversLeave.vue?vue&type=script&lang=ts&"
export * from "./DriversLeave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports